<template>
  <div class="s-spinner">
    <div class="s-spinner-bounce1"></div>
    <div class="s-spinner-bounce2"></div>
    <div class="s-spinner-bounce3"></div>
  </div>
</template>

<script>
export default {
  name: "s-spinner",
};
</script>

<style>
.s-spinner {
  margin: auto;
  text-align: center;
}

.s-spinner>div {
  width: var(--spinner-size, 18px);
  height: var(--spinner-size, 18px);
  display: inline-block;
  animation: s-spinner-bouncedelay 1s infinite ease-in-out both;
  border-radius: 100%;
  background-color: var(--spinner-color, #000);
}

.s-spinner .s-spinner-bounce1 {
  animation-delay: -0.32s;
}

.s-spinner .s-spinner-bounce2 {
  animation-delay: -0.16s;
}

@keyframes s-spinner-bouncedelay {

  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }

  40% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}
</style>